import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#fdfd96",
            border: "2px solid #2d2d2d",
            color: "#2d2d2d",
            fontFamily: "'Caveat Brush', cursive",
            fontSize: "1.25rem",
            boxShadow: "6px 6px 0 0 #2d2d2d",
            borderRadius: "4px",
          },
        }}
      />
    </div>
  );
}

export default App;
